import { useEffect } from 'react';
import "@/App.css";
import { LanguageProvider } from '@/context/LanguageContext';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Lenis from 'lenis';
import SEOHead from '@/components/SEOHead';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import MarqueeRibbon from '@/components/MarqueeRibbon';
import Services from '@/components/Services';
import Portfolio from '@/components/Portfolio';
import About from '@/components/About';
import Testimonials from '@/components/Testimonials';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import ChatWidget from '@/components/ChatWidget';
import AdminDashboard from '@/components/AdminDashboard';
import ProjectDetail from '@/components/ProjectDetail';

function MainSite() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, duration: 1.2 });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  return (
    <div className="bg-zinc-950 min-h-screen">
      <SEOHead />
      <Header />
      <main>
        <Hero />
        <MarqueeRibbon />
        <Services />
        <Portfolio />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainSite />} />
            <Route path="/project/:slug" element={<ProjectDetail />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
